import { createApp } from 'vue';

import { defaultOptions, registerCorePlugins } from '@deepidoo/deesplay-core/plugins';

import '@deepidoo/deesplay-shared/styles/globals.scss';
import '@deepidoo/deesplay-core/styles/globals.scss';

import App from './App.vue';

const app = createApp(App);

registerCorePlugins(app, defaultOptions.value);

app.mount('#deesplay');